import { render, staticRenderFns } from "./MarketingServicesView.vue?vue&type=template&id=daa58562"
import script from "./MarketingServicesView.vue?vue&type=script&lang=js"
export * from "./MarketingServicesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports